export const workspacesKeys = {
    all: ['workspaces'] as const,
    lists: () => [...workspacesKeys.all, 'list'] as const,
    list: (filters: Record<string, unknown>) => [...workspacesKeys.lists(), { filters }] as const,

    details: () => [...workspacesKeys.all, 'detail'] as const,
    detail: (id: string) => [...workspacesKeys.details(), id] as const,
} as const;

// ms
export const WORKSPACE_REFETCH_INTERVAL = 1000 * 1;
